import { useState } from 'react';
import Typography from '@mui/material/Typography';
import { FormattedMessage } from 'react-intl';
import { useLocalization } from '@ui-framework/index';
import { Button, Card, Divider, IconButton, Slide } from '@mui/material';
import Grid2 from '@thirdparty-framework/mui/material/Grid';
import HighlightOffRoundedIcon from '@mui/icons-material/HighlightOffRounded';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import StarIcon from '@mui/icons-material/Star';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import KeyboardDoubleArrowUpIcon from '@mui/icons-material/KeyboardDoubleArrowUp';
import ServiceIcon from './ServiceIcon';
import LegendBlock from './LegendBlock';

export default function Legend() {
  const [open, setOpen] = useState(false);
  const { formatMessage } = useLocalization();

  return (
    <div>
      <Button
        variant="contained"
        sx={{
          position: 'absolute',
          bottom: '55px',
          right: '50px',
          zIndex: 2,
          textTransform: 'none',
          padding: '2px 6px',
          fontSize: '12px',
          background: '#ffffff',
          color: '#000000',
          ':hover': {
            background: '#efefef',
          },
        }}
        onClick={() => setOpen(true)}>
        <FormattedMessage id="SERVICEJOB_SHOW_LEGEND" defaultMessage="Legend" />
        <KeyboardDoubleArrowUpIcon
          fontSize="small"
          sx={{ marginLeft: '5px' }}
        />
      </Button>
      <Slide direction="up" in={open} mountOnEnter unmountOnExit>
        <Card
          elevation={8}
          sx={{
            position: 'absolute',
            bottom: '10px',
            right: '50px',
            padding: '5px 8px',
            minWidth: '300px',
            zIndex: 2,
          }}>
          <Grid2 sx={{ marginBottom: '10px' }}>
            <IconButton
              onClick={() => setOpen(false)}
              sx={{
                position: 'absolute',
                right: 0,
                top: '-2px',
              }}
              size="small"
              variant="contained">
              <HighlightOffRoundedIcon />
            </IconButton>
            <Typography
              variant="h6"
              sx={{ fontSize: '16px', color: 'primary.main' }}>
              <FormattedMessage
                id="SERVICE_PROVIDER_MATCH_LEGEND"
                defaultMessage="Service Provider Match Legend"
              />
            </Typography>
            <Divider />
          </Grid2>

          <Grid2>
            <LegendBlock
              item={{
                name: formatMessage({
                  id: 'LEGEND_SERVICES_BRAND',
                  defaultMessage: 'Services Brand',
                }),
                Icon: ServiceIcon,
                iconProps: { startAngle: 0, endAngle: 90 },
              }}
            />
            <LegendBlock
              item={{
                name: formatMessage({
                  id: 'LEGEND_SERVICES_INDUSTRY',
                  defaultMessage: 'Services Industry',
                }),
                Icon: ServiceIcon,
                iconProps: { startAngle: 90, endAngle: 180 },
              }}
            />
            <LegendBlock
              item={{
                name: formatMessage({
                  id: 'LEGEND_PREVIOSULY_REJECTED',
                  defaultMessage: 'Previously Rejected',
                }),
                Icon: ServiceIcon,
                iconProps: { startAngle: 180, endAngle: 270 },
              }}
            />
            <LegendBlock
              item={{
                name: formatMessage({
                  id: 'LEGEND_SERVICES_PRODUCT_LINE',
                  defaultMessage: 'Services Product Line',
                }),
                Icon: ServiceIcon,
                iconProps: { startAngle: 270, endAngle: 0 },
              }}
            />
            <Divider sx={{ marginBottom: '10px' }} />
            <LegendBlock
              item={{
                name: formatMessage({
                  id: 'LEGEND_CONDITIONALLY_ACCEPTED',
                  defaultMessage: 'Conditionally Accepted',
                }),
                Icon: StarIcon,
                iconProps: { sx: { color: 'success.main' } },
              }}
            />
            <LegendBlock
              item={{
                name: formatMessage({
                  id: 'LEGEND_SENT_PREVIOSULY',
                  defaultMessage: 'Sent Previously',
                }),
                Icon: StarBorderIcon,
                iconProps: { sx: { color: 'success.main' } },
              }}
            />
            <LegendBlock
              item={{
                name: formatMessage({
                  id: 'LEGEND_NON_COMPLIANT',
                  defaultMessage: 'Non-Compliant',
                }),
                Icon: ReceiptLongIcon,
                iconProps: { sx: { color: 'warning.light' } },
              }}
            />
            <LegendBlock
              item={{
                name: formatMessage({
                  id: 'LEGEND_IN_ACTIVE',
                  defaultMessage: 'Inactive',
                }),
                Icon: WarningAmberIcon,
                iconProps: { sx: { color: 'error.main' } },
              }}
            />
          </Grid2>
        </Card>
      </Slide>
    </div>
  );
}
